import Component from '../core/Component'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { SwipeDetect } from '../plugins/SwipeDetect'

export const STATES = {
    IS_PREV_VISIBLE: 'is-prev-visible',
    IS_NEXT_VISIBLE: 'is-next-visible',
    READY: 'is-ready'
}

export default class SpecialOfferSlider extends Component {

    constructor(element, options) {
        super(element, options = {
            itemsPerPage: 3
        })

        this.ref = {
            slider: null,
            dotContainer: null,
            nexts: [],
            prevs: [],
            items: [],
            cards: []
        }

        this.enquireLargeUpHandler = {
            match: () => {
                this.destroyMobileFlickity()
                this.createDesktopSlider()
            }
        }

        this.enquireMediumMaxHandler = {
            match: () => {
                this.destroyDesktopSlider()
                this.createMobileFlickity()
            }
        }

        this.mobileFlickity = null
        this.pageIndex = null
        this.activeCards = []
        this.cards = []
    }

    prepare() {
        this.cards = this.ref.cards.map(cardEl => Component.getFromElement(cardEl))


        enquire.register(queries.largeUp, this.enquireLargeUpHandler)
        enquire.register(queries.mediumMax, this.enquireMediumMaxHandler)

        this.ref.nexts.forEach(next => next.addEventListener('click', this.handleNextClick))
        this.ref.prevs.forEach(prev => prev.addEventListener('click', this.handlePrevClick))

        this.element.classList.add(STATES.READY)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireLargeUpHandler)
        enquire.unregister(queries.mediumMax, this.enquireMediumMaxHandler)

        if (this.isDesktopSlider) {
            this.destroyDesktopSlider()
        }

        if (this.mobileFlickity) {
            this.destroyMobileFlickity()
        }
    }


    //MOBILE VERZE
    createMobileFlickity() {
        if (this.mobileFlickity) {
            return
        }

        this.mobileFlickity = new Flickity(this.ref.slider,{
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            groupCells: '100%',
            adaptiveHeight: true
        })
    }

    destroyMobileFlickity() {
        this.mobileFlickity?.destroy()
        this.mobileFlickity = null
    }



    //DESKTOP VERZE
    handleNextClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.next()
        } else{
            this.selectNextPage()
        }
    }

    handlePrevClick = () => {
        if (this.mobileFlickity) {
            this.mobileFlickity.previous()
        } else{
            this.selectPreviousPage()
        }
    }

    handleDotsClick = event => {
        const dot = event.target
        const index = [...this.ref.dotContainer.children].indexOf(dot)
        this.selectPage(index)
    }

    createDesktopSlider() {
        if (this.isDesktopSlider) {
            return
        }

        this.pageIndex = null
        this.createDots()

        this.cards.forEach(card => card?.hide(false))

        this.ref.dotContainer.addEventListener('click', this.handleDotsClick)

        this.selectPage(0)

        if (!this.swipeDetect) {
            this.swipeDetect = new SwipeDetect(this.element)
            this.swipeDetect.on('swipe-right', () => this.selectPreviousPage())
            this.swipeDetect.on('swipe-left', () => this.selectNextPage())
        }

        this.isDesktopSlider = true
    }

    destroyDesktopSlider() {
        this.ref.dotContainer.removeEventListener('click', this.handleDotsClick)

        this.cards.forEach(card => card?.show(false))

        if (this.swipeDetect) {
            this.swipeDetect.destroy()
            this.swipeDetect = null
        }

        this.isDesktopSlider = false
        this.ref.slider.style.maxHeight = ''
    }

    createDots() {
        let dots = ''
        const count = this.ref.cards.length / this.options.itemsPerPage

        if (count <= 1) {
            return
        }

        for (let index = 0; index < count; index++) {
            dots += `<span class="dot ${this.pageIndex === index ? 'is-selected':''}"></span>`
        }

        this.ref.dotContainer.innerHTML = dots
    }

    checkPrevNext() {
        const count = Math.ceil(this.ref.cards.length / this.options.itemsPerPage)

        if (this.pageIndex !== count - 1 && count !== 1) {
            this.element.classList.add(STATES.IS_NEXT_VISIBLE)
        } else {
            this.element.classList.remove(STATES.IS_NEXT_VISIBLE)
        }

        if (this.pageIndex !== 0) {
            this.element.classList.add(STATES.IS_PREV_VISIBLE)
        } else {
            this.element.classList.remove(STATES.IS_PREV_VISIBLE)
        }
    }

    checkDots() {
        const dots = [...this.ref.dotContainer.children]
        dots.forEach(dot => dot.classList.remove('is-selected'))
        this.ref.dotContainer.children[this.pageIndex]?.classList.add('is-selected')
    }

    selectPreviousPage() {
        const pageIndex = Math.max(this.pageIndex - 1, 0)
        this.selectPage(pageIndex)
    }

    selectNextPage() {
        const pageIndex = Math.ceil(Math.min(this.pageIndex + 1, this.ref.cards.length / this.options.itemsPerPage - 1))
        this.selectPage(pageIndex)
    }

    selectPage(pageIndex) {
        if (pageIndex === this.pageIndex) {
            return
        }

        this.pageIndex = pageIndex

        this.activeCards.forEach((card, index) => {
            setTimeout(() => {
                card.hide()
            }, index * 100)
        })

        const activeCards = this.cards.slice(pageIndex * this.options.itemsPerPage,pageIndex * this.options.itemsPerPage + this.options.itemsPerPage)

        this.activeCards = activeCards

        activeCards.forEach((card, index) => {
            setTimeout(() => {
                card.show()
            }, index * 100)
        })

        this.ref.slider.style.maxHeight = `${Math.max(...activeCards.map(card => card.element.offsetHeight))+2}px`

        this.checkDots()
        this.checkPrevNext()
    }
}
